// languageConfig.js — Milo Speaks Spanish
// Single source of truth for all language-specific values.
// To clone for a new language pair, copy this file and update every value.
// Import this wherever a hardcoded language string currently exists.

export const languageConfig = {
  appId: "milo-es-en",
  sourceLanguage: "es",
  targetLanguage: "en",
  sourceLanguageCode: "es-ES",
  targetLanguageCode: "en-US",
  sourceLanguageName: "Spanish",
  targetLanguageName: "English",
  drillDirectionId: "es-en",
  reverseDrillDirectionId: "en-es",
  drillDirectionLabel: "SP→EN",
  reverseDrillDirectionLabel: "EN→SP",
  deeplSourceCode: "ES",
  deeplTargetCode: "EN-US",
  uiLocale: "en",
  displayName: "Milo Speaks Spanish",
  dateLocale: "es-ES",
};
